import { Link } from '@remix-run/react'
import SocialIcons from '../components/socialIcons'

const Header = () => {
  return (
    <footer className="text-white py-8 lg:px-24 px-4 bg-secondary">
      <div className="container mx-auto flex flex-wrap justify-between items-center">
        <div>
          <div className="mb-4">
            <Link to="/">
              <span
                className="block w-24 h-12 bg-center bg-no-repeat bg-cover"
                style={{
                  backgroundImage: 'url(/images/logo.png)',
                }}
              ></span>
            </Link>
          </div>
          <div className="text-body-sm space-x-2 mb-2">
            <Link to="/terms" className="hover:underline" reloadDocument>
              Terms of service
            </Link>
            <span>|</span>
            <Link to="/privacy-policy" className="hover:underline" reloadDocument>
              Privacy policy
            </Link>
            <span>|</span>
            <Link to="/press-kit" className="hover:underline" reloadDocument>
              Press kit
            </Link>
          </div>
          {/* Charitable number shown only on mobile */}
          <div className="text-grey50 text-sm xl:hidden mb-2">Charitable registration number: 785491341 RR 0001</div>
          <div className="text-body-sm text-grey50 mb-2">
            Copyright {new Date().getFullYear()} TalentLift Canada. All Rights Reserved.
          </div>
          <div className="text-body-sm text-grey50 mb-2">
            Data is refreshed regularly. Most figures are updated daily or as new information becomes available. Last
            updated: <time dateTime={new Date().toISOString()}>{new Date().toLocaleDateString('en-CA')}</time>
          </div>
        </div>

        {/* Desktop social + charitable number */}
        <div className="hidden xl:flex flex-col items-end space-y-2">
          <div className="flex space-x-4">
            <SocialIcons iconColor="text-white" iconHover="text-grey30" iconSize="fa-lg" />
          </div>
          <div className="text-grey50 text-sm">Charitable registration number: 785491341 RR 0001</div>
        </div>

        {/* Mobile social icons - shown below text on smaller screens */}
        <div className="flex justify-center xl:hidden mt-4 space-x-4">
          <SocialIcons iconColor="text-white" iconHover="text-grey30" iconSize="fa-lg" />
        </div>
      </div>
    </footer>
  )
}

export default Header
